import { useFetch } from '@gluedigital/ruse-fetch-extras'
import { ADMIN_URL } from 'src/constants/global'

interface CompanyTagsResponse {
  ok: boolean
  tags: string[]
}

export const useCompanyTags = (): string[] => {
  const { tags } = useFetch<CompanyTagsResponse>(ADMIN_URL + '/companies/tags')
  return tags
}
